export const PERMISSION_ROLES = [
  { key: 'super_admin', label: 'Super admin', locked: true },
  { key: 'admin_depo', label: 'Admin depo' },
  { key: 'admin_rrhh', label: 'Admin RRHH' },
  { key: 'ventas', label: 'Ventas' },
  { key: 'referentes', label: 'Referentes' },
  { key: 'logistico', label: 'Logístico' },
];

export const PERMISSION_RESOURCES = [
  { key: 'agenda', module: 'Agenda', section: 'Eventos y tareas', path: '/' },
  { key: 'agenda.personal-pdf', module: 'Agenda', section: 'PDF Personal', path: 'Acción en Agenda' },
  { key: 'agenda.equipos', module: 'Agenda', section: 'Equipos generales', path: '/equipos' },
  { key: 'agenda.equipos.evento', module: 'Agenda', section: 'Equipos por evento', path: '/agenda/eventos/:eventId/equipos' },
  { key: 'logistica', module: 'Logística', section: 'Traslados y checklist', path: '/logistics' },
  { key: 'lugares-activos', module: 'Operación', section: 'Lugares activos', path: '/locations' },
  { key: 'inventario.stock', module: 'Inventario', section: 'Stock', path: '/inventory/stock' },
  { key: 'inventario.racks', module: 'Inventario', section: 'Racks', path: '/inventory/racks' },
  { key: 'inventario.packs', module: 'Inventario', section: 'Packs', path: '/inventory/packs' },
  { key: 'inventario.incidencias', module: 'Inventario', section: 'Incidencias', path: '/inventory/incidencias' },
  { key: 'ventas.leads', module: 'Ventas', section: 'Leads', path: '/ventas/leads' },
  { key: 'ventas.cotizaciones', module: 'Ventas', section: 'Cotizaciones', path: '/ventas/cotizaciones' },
  { key: 'ventas.clientes', module: 'Ventas', section: 'Clientes', path: '/ventas/clientes' },
  { key: 'ventas.proveedores', module: 'Ventas', section: 'Proveedores', path: '/ventas/proveedores' },
  { key: 'ventas.productos', module: 'Ventas', section: 'Productos', path: '/ventas/productos' },
  { key: 'ventas.lugares', module: 'Ventas', section: 'Lugares', path: '/ventas/lugares' },
  { key: 'rrhh.plan-mensual', module: 'Horas', section: 'Control', path: '/rrhh/plan-mensual' },
  { key: 'rrhh.plan-semanal', module: 'Horas', section: 'Plan semanal', path: '/rrhh/plan-semanal' },
  { key: 'rrhh.tareas', module: 'Horas', section: 'Tareas administrativas', path: '/rrhh/tareas' },
  { key: 'rrhh.incidencias', module: 'Horas', section: 'Incidencias de personal', path: '/rrhh/incidencias' },
  { key: 'rrhh.jornales', module: 'Horas', section: 'Validación de jornales', path: '/rrhh/jornales' },
  { key: 'rrhh.operaciones', module: 'Horas', section: 'Validación de operaciones', path: '/rrhh/operaciones' },
  { key: 'rrhh.dashboard', module: 'Horas', section: 'Dashboard', path: '/rrhh/dashboard' },
  { key: 'rrhh.reportes', module: 'Horas', section: 'Reportes', path: '/rrhh/reportes' },
  { key: 'rrhh.analisis', module: 'Horas', section: 'Análisis', path: '/rrhh/analisis' },
  { key: 'rrhh.liquidacion', module: 'Empleados', section: 'Liquidación', path: '/sueldos/liquidacion' },
  { key: 'rrhh.remuneraciones', module: 'Empleados', section: 'Tarifas personales', path: '/sueldos/tarifas-personal' },
  { key: 'rrhh.liquidacion-parametros', module: 'Empleados', section: 'Parámetros de liquidación', path: '/sueldos/parametros' },
  { key: 'rrhh.liquidacion-cierre', module: 'Empleados', section: 'Cierre de liquidación', path: 'Acción en Liquidación' },
  { key: 'rrhh.mis-marcas', module: 'Horas', section: 'Mis marcas', path: '/rrhh/mis-marcas' },
  { key: 'rrhh.reloj', module: 'Horas', section: 'Reloj', path: '/rrhh/reloj' },
  { key: 'rrhh.configuracion', module: 'Horas', section: 'Configuración', path: '/rrhh/configuracion' },
  { key: 'configuracion.personal', module: 'Empleados', section: 'Personal global', path: '/sueldos/personal' },
  { key: 'configuracion.biometria', module: 'Configuración', section: 'Biometría', path: '/configuracion/biometria' },
  { key: 'configuracion.permisos', module: 'Configuración', section: 'Permisos', path: '/configuracion/permisos' },
  { key: 'configuracion.ia', module: 'Configuración', section: 'Reglas de IA', path: '/configuracion/ia' },
  { key: 'configuracion.sistema', module: 'Configuración', section: 'Sistema e integraciones', path: 'Integración interna' },
];

export function defaultPermissionMatrix() {
  const matrix = Object.fromEntries(PERMISSION_ROLES.map(role => [
    role.key,
    Object.fromEntries(PERMISSION_RESOURCES.map(resource => [resource.key, 'none'])),
  ]));

  PERMISSION_RESOURCES.forEach(resource => { matrix.super_admin[resource.key] = 'write'; });
  Object.assign(matrix.admin_depo, {
    agenda: 'write',
    'agenda.equipos': 'write',
    'agenda.equipos.evento': 'write',
    logistica: 'write',
    'lugares-activos': 'read',
    'inventario.stock': 'write',
    'inventario.racks': 'write',
    'inventario.packs': 'write',
    'inventario.incidencias': 'write',
    'rrhh.reloj': 'read',
  });
  PERMISSION_RESOURCES
    .filter(resource => resource.key.startsWith('rrhh.'))
    .forEach(resource => { matrix.admin_rrhh[resource.key] = 'write'; });
  matrix.admin_rrhh['configuracion.personal'] = 'write';
  matrix.admin_rrhh['configuracion.biometria'] = 'write';
  Object.assign(matrix.ventas, {
    agenda: 'write',
    'agenda.equipos': 'write',
    'agenda.equipos.evento': 'write',
    'lugares-activos': 'read',
    'rrhh.reloj': 'read',
    'ventas.leads': 'write',
    'ventas.cotizaciones': 'write',
    'ventas.clientes': 'write',
    'ventas.proveedores': 'write',
    'ventas.productos': 'write',
    'ventas.lugares': 'write',
  });
  Object.assign(matrix.referentes, {
    agenda: 'read',
    'agenda.equipos': 'read',
    'agenda.equipos.evento': 'write',
    logistica: 'read',
    'lugares-activos': 'read',
    'inventario.stock': 'read',
    'inventario.racks': 'read',
    'inventario.packs': 'read',
    'inventario.incidencias': 'read',
    'rrhh.reloj': 'read',
  });
  Object.assign(matrix.logistico, {
    agenda: 'read',
    'agenda.equipos': 'read',
    'agenda.equipos.evento': 'read',
    logistica: 'read',
    'lugares-activos': 'read',
    'inventario.stock': 'read',
    'inventario.racks': 'read',
    'inventario.packs': 'read',
    'inventario.incidencias': 'read',
    'rrhh.reloj': 'read',
  });

  return matrix;
}
